import { actionTypes } from './constants';


const initialState = {
    maintenanceSchedule: {
        data: {},
        error: null,
        loadingStatus: null
    },
    microServiceMaintenance: [],
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_MAINTENANCE_SCHEDULE_SETTINGS:
            return {
                ...state,
                maintenanceSchedule: {
                    ...state.maintenanceSchedule,
                    ...action
                }
            };
        case actionTypes.ADD_MAINTENANCE_SCHEDULE_SETTINGS:
            return {
                ...state,
                maintenanceSchedule: { ...state.maintenanceSchedule, ...action },
            };
        case actionTypes.GET_MAINTENANCE_SCHEDULE_SETTINGS_MICRO_SERVICE:
            return {
                ...state,
                microServiceMaintenance: action.scheduleData
            };
        case actionTypes.CLEAR_STORE:
            return initialState;
        default:
            return state;
    }
}

